import {Component, OnInit} from '@angular/core';
import {fadeInRightAnimation} from '../../../@fury/animations/fade-in-right.animation';
import {scaleInAnimation} from '../../../@fury/animations/scale-in.animation';
import {fadeInUpAnimation} from '../../../@fury/animations/fade-in-up.animation';
import {LayoutService} from '../../layout/layout.service';

@Component({
  selector: 'fury-form-selector',
  templateUrl: './form-selector.component.html',
  styleUrls: ['./form-selector.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class FormSelectorComponent implements OnInit {

  constructor(private layoutService: LayoutService,
  ) {
  }

  ngOnInit(): void {
    this.layoutService.isPublicNotificationVisible.emit(true);
  }
}
